import React from "react";

// Plain inline SVG icons — no npm install required. Every icon your Careers
// pages import comes from here instead of "lucide-react". Same call shape
// as lucide (<IconName size={18} />), so nothing else in your JSX changes.
//
// Need one more icon later? Copy the Base() pattern below, drop in your own
// <path>/<circle>/<line> children, and export it the same way.

function Base({ size = 20, children, ...props }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      {children}
    </svg>
  );
}

export const MapPin = (p) => (
  <Base {...p}>
    <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z" />
    <circle cx="12" cy="10" r="3" />
  </Base>
);

export const ArrowRight = (p) => (
  <Base {...p}>
    <line x1="4" y1="12" x2="20" y2="12" />
    <polyline points="14 6 20 12 14 18" />
  </Base>
);

export const ArrowLeft = (p) => (
  <Base {...p}>
    <line x1="20" y1="12" x2="4" y2="12" />
    <polyline points="10 6 4 12 10 18" />
  </Base>
);

export const Zap = (p) => (
  <Base {...p}>
    <polygon points="13 2 4 14 11 14 10 22 20 10 13 10 13 2" />
  </Base>
);

export const Rocket = (p) => (
  <Base {...p}>
    <path d="M5 16s-1.5 1.5-1.5 4.5C6.5 20.5 8 19 8 19" />
    <path d="M12 15c3.5-3.5 7-8.5 6-13-4.5-1-9.5 2.5-13 6-1.5 1.5-2 3-2 3l6 6s1.5-.5 3-2Z" />
    <circle cx="14.5" cy="9.5" r="1.5" />
  </Base>
);

export const TrendingUp = (p) => (
  <Base {...p}>
    <polyline points="3 17 9 11 13 15 21 6" />
    <polyline points="15 6 21 6 21 12" />
  </Base>
);

export const Users = (p) => (
  <Base {...p}>
    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
    <circle cx="9" cy="7" r="4" />
    <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
    <path d="M16 3.13a4 4 0 0 1 0 7.75" />
  </Base>
);

export const UsersRound = Users;

export const GraduationCap = (p) => (
  <Base {...p}>
    <path d="M22 10 12 5 2 10l10 5 10-5Z" />
    <path d="M6 12v5c0 1.5 2.5 3 6 3s6-1.5 6-3v-5" />
  </Base>
);

export const Venus = (p) => (
  <Base {...p}>
    <circle cx="12" cy="8" r="5" />
    <line x1="12" y1="13" x2="12" y2="21" />
    <line x1="9" y1="18" x2="15" y2="18" />
  </Base>
);

export const UserPlus = (p) => (
  <Base {...p}>
    <path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
    <circle cx="8.5" cy="7" r="4" />
    <line x1="19" y1="8" x2="19" y2="14" />
    <line x1="16" y1="11" x2="22" y2="11" />
  </Base>
);

export const Shield = (p) => (
  <Base {...p}>
    <path d="M12 2 4 5v6c0 5 3.5 9 8 11 4.5-2 8-6 8-11V5l-8-3Z" />
    <polyline points="9 12 11 14 15 10" />
  </Base>
);

export const Lightbulb = (p) => (
  <Base {...p}>
    <path d="M9 18h6" />
    <path d="M10 22h4" />
    <path d="M12 2a6 6 0 0 0-4 10.5c.6.6 1 1.5 1 2.5h6c0-1 .4-1.9 1-2.5A6 6 0 0 0 12 2Z" />
  </Base>
);

export const ThumbsUp = (p) => (
  <Base {...p}>
    <path d="M7 10v11" />
    <path d="M11 21h6.5a2 2 0 0 0 2-1.6l1.3-6.5a2 2 0 0 0-2-2.4H14V5a2.5 2.5 0 0 0-5 0l-1 5H4a1 1 0 0 0-1 1v9a1 1 0 0 0 1 1h3" />
  </Base>
);

export const Globe2 = (p) => (
  <Base {...p}>
    <circle cx="12" cy="12" r="10" />
    <path d="M2 12h20" />
    <path d="M12 2a15 15 0 0 1 0 20 15 15 0 0 1 0-20Z" />
  </Base>
);

export const HeartPulse = (p) => (
  <Base {...p}>
    <path d="M19 14c1.5-1.5 3-3.4 3-5.5A4.5 4.5 0 0 0 13.5 6L12 7.5 10.5 6A4.5 4.5 0 0 0 2 8.5c0 2.1 1.5 4 3 5.5l7 7 3-3" />
    <polyline points="3.5 11 7 11 8.5 8.5 10.5 13.5 12 11 22 11" />
  </Base>
);

export const History = (p) => (
  <Base {...p}>
    <path d="M3 12a9 9 0 1 0 3-6.7" />
    <polyline points="3 3 3 8 8 8" />
    <polyline points="12 7 12 12 16 14" />
  </Base>
);

export const Coins = (p) => (
  <Base {...p}>
    <circle cx="9" cy="9" r="6" />
    <path d="M14.5 9.5a6 6 0 1 0-6 6.5" />
    <circle cx="15" cy="15" r="6" />
  </Base>
);

export const BookOpen = (p) => (
  <Base {...p}>
    <path d="M2 5c2 0 5 .5 6.5 2.5v13C7 18.5 4 18 2 18Z" />
    <path d="M22 5c-2 0-5 .5-6.5 2.5v13c1.5-2 4.5-2.5 6.5-2.5Z" />
  </Base>
);

export const BatteryCharging = (p) => (
  <Base {...p}>
    <rect x="1" y="7" width="16" height="10" rx="2" />
    <line x1="21" y1="10" x2="21" y2="14" />
    <polyline points="10 8 7 12 10 12 8 16" />
  </Base>
);

export const Quote = (p) => (
  <Base {...p}>
    <path d="M9 6a4 4 0 0 0-4 4v3a2 2 0 0 0 2 2h2v-6H7a2 2 0 0 1 2-2Z" />
    <path d="M19 6a4 4 0 0 0-4 4v3a2 2 0 0 0 2 2h2v-6h-2a2 2 0 0 1 2-2Z" />
  </Base>
);

export const ChevronDown = (p) => (
  <Base {...p}>
    <polyline points="6 9 12 15 18 9" />
  </Base>
);

export const Mail = (p) => (
  <Base {...p}>
    <rect x="2" y="4" width="20" height="16" rx="2" />
    <polyline points="2 6 12 13 22 6" />
  </Base>
);

export const Search = (p) => (
  <Base {...p}>
    <circle cx="11" cy="11" r="7" />
    <line x1="21" y1="21" x2="16.65" y2="16.65" />
  </Base>
);

export const Briefcase = (p) => (
  <Base {...p}>
    <rect x="2" y="7" width="20" height="14" rx="2" />
    <path d="M8 7V5a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" />
    <line x1="2" y1="13" x2="22" y2="13" />
  </Base>
);

export const Wallet = (p) => (
  <Base {...p}>
    <path d="M20 7H5a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h15a1 1 0 0 0 1-1v-3" />
    <path d="M18 12h3v4h-3a2 2 0 0 1 0-4Z" />
    <path d="M3 9V6a2 2 0 0 1 2-2h11" />
  </Base>
);

export const Clipboard = (p) => (
  <Base {...p}>
    <rect x="5" y="4" width="14" height="17" rx="2" />
    <rect x="9" y="2" width="6" height="4" rx="1" />
  </Base>
);

export const Check = (p) => (
  <Base {...p}>
    <polyline points="20 6 9 17 4 12" />
  </Base>
);

export const Linkedin = (p) => (
  <Base {...p}>
    <rect x="2" y="9" width="4" height="12" />
    <circle cx="4" cy="4" r="2" />
    <path d="M10 21v-7a3 3 0 0 1 6 0v7" />
    <line x1="10" y1="12" x2="10" y2="21" />
  </Base>
);

export const MessageCircle = (p) => (
  <Base {...p}>
    <path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5Z" />
  </Base>
);

export const Share2 = (p) => (
  <Base {...p}>
    <circle cx="18" cy="5" r="3" />
    <circle cx="6" cy="12" r="3" />
    <circle cx="18" cy="19" r="3" />
    <line x1="8.6" y1="10.5" x2="15.4" y2="6.5" />
    <line x1="8.6" y1="13.5" x2="15.4" y2="17.5" />
  </Base>
);

export const User = (p) => (
  <Base {...p}>
    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
    <circle cx="12" cy="7" r="4" />
  </Base>
);